<sc-lateral-drawer-light-box [class.show]="showLateralMenu" (close)="close()">
  <div class="sc-nav-panel-submenu" [class.open]="showLateralMenu" @slideInOut *ngIf="panel">
    <div class="sc-nav-panel-submenu__content">
      <div class="sc-nav-panel-submenu__content__header">
        <span (click)="close()" class="sc-nav-panel-submenu__content__header__close icon-arrow-left-big"></span>
        <p class="sc-nav-panel-submenu__content__header__title">{{panel.label}}</p>
      </div>
      <div class="sc-nav-panel-submenu__content__items">
        <sc-nav-items
          [firstLevel]="firstLevel"
          [highlightActive]="highlightActive"
          [menu]="panel"
          (itemClicked)="onItemClicked($event)"
        >
        </sc-nav-items>
      </div>
    </div>
  </div>
</sc-lateral-drawer-light-box>
